export const aboutLinks = [
    {
        id: 1,
        link: 'https://www.linkedin.com/in/dagna-schmidt-90ba37207/',
        title: 'LinkedIn'
    },
    {
        id: 2,
        link: 'https://github.com/DagnaSchmidt',
        title: 'GitHub'
    },
    {
        id: 3,
        link: 'https://dribbble.com/dagnaS',
        title: 'Dribbble'
    },
    {
        id: 4,
        link: 'https://www.instagram.com/b.ardzo/',
        title: 'Instagram'
    }
]
